import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { path } from 'ramda';

import { loadExtendedDetailsByCarrierFlightNumberAndDate, loadById } from '../../../SingleFlight/redux/actions';
import componentBase from '../../../../src/lib/component-base';
import HistoricalFlightTrackerComponent from '../../../HistoricalFlightStatus/components/HistoricalFlightTracker/children/FlightTracker/HistoricalFlightTracker';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import Ad from '../../../../shared/components/Ad/Ad';
import { ExtendedDetails as extendedDetailsAds } from '../ads';
import onResize from '../../../../src/lib/on-resize';
import { flightURL } from '../../../../src/lib/single-flight-util';
import { isNilOrEmpty } from '../../../../src/lib/ramda-extension';

@connect(state => ({
  error: state.SingleFlightTracker.error,
  loading: state.SingleFlightTracker.loading,
  loaded: state.SingleFlightTracker.loaded,
  extendedData: state.SingleFlightTracker.extendedData,
  flight: state.SingleFlightTracker.flight,
}))
@onResize()
@componentBase('ExtendedDetails')
export default class ExtendedDetails extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    error: PropTypes.object,
    extendedData: PropTypes.object,
    flight: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    name: PropTypes.string,
    params: PropTypes.object,
  };

  componentDidMount() {
    const { dispatch } = this.props;

    this.loadFlight(this.props);

    this.initResizeListener();
    this.forceUpdate();

    let errorCode = null;

    if (this.props.error) {
      errorCode = this.props.error.code;
    }

    if (errorCode) {
      dispatch(push(`/flight-tracker/search/advanced?error=${errorCode}`));
    }
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, location: prevLocation } = this.props;
    const { pathname: prevPathname } = prevLocation;
    const {
      error, flight, extendedData, location: nextLocation,
    } = nextProps;
    const { pathname: nextPathname } = nextLocation;

    if (error && error.code) {
      dispatch(push(`/flight-tracker/search/advanced?error=${error.code}`));
      return;
    }

    // update on the click of another segment stop
    if (prevPathname !== nextPathname) {
      this.loadFlight(nextProps);
    } else if (!isNilOrEmpty(flight) && isNilOrEmpty(extendedData)) {
      // The flight was loaded by flightId without using the date
      const redirPathname = `/flight-details/${flightURL(flight)}`;
      (nextPathname !== redirPathname) && dispatch(replace(redirPathname));
    }
  }

  componentWillUnmount() {
    this.removeResizeListener();
  }

  loadFlight = (props) => {
    const { dispatch, match } = props;
    const { params } = match;
    const {
      flightId, year, month, day,
    } = params;

    if (year && month && day) {
      dispatch(loadExtendedDetailsByCarrierFlightNumberAndDate(params));
    } else {
      dispatch(loadById(flightId));
    }
  };

  handleResize = () => this.forceUpdate();

  render() {
    const {
      dispatch,
      extendedData,
      match,
    } = this.props;
    const props = {
      details: extendedData,
      dispatch,
      hasCredits: true,
      match,
    };

    const subscriptionActive = path(['context', 'currentUser', 'subscriptionActive'], this);

    const {
      topMobile,
      top,
      left,
      right,
    } = extendedDetailsAds;

    const topAd = (
      <BannerAd
        topAd
        mobileAd={topMobile}
        desktopAd={top}
        subscriptionActive={subscriptionActive}
      />
    );

    let ads = null;
    if (!subscriptionActive) {
      ads = [
        (<center className='col-xs-12 col-sm-6' key={`${left.id}-div-center`}>
          <Ad key={left.id} {...left} />
        </center>),
      ];
      if (path(['mediaBreakpoint', 'value'], this) > 769) {
        ads.push((<center className='hidden-xs col-sm-6' key={`${right.id}-div-center`}>
          <Ad key={right.id} {...right} />
        </center>));
      }
    }

    return (
      <div className='container'>
        {topAd}
        <HistoricalFlightTrackerComponent
          {...props}
          extendedDetails
          extendedDetailsAds={ads}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/FlightTracker/components/ExtendedDetails/container.js